export default "__VITE_ASSET__Dqf5zcrL__"